import { createAsyncThunk } from '@reduxjs/toolkit';

import { journeyAPI } from '@/modules/journey/api';
import { namespace } from '@/modules/journey/namespace';

const requestJourneyReport = createAsyncThunk(
  `${namespace}/request-journey-report`,
  async ({ driverId, from, to }: { driverId?: string; from?: string; to?: string }) =>
    journeyAPI.requestJourneyReport({ driverId, from, to }),
);

export { requestJourneyReport };
